window.KCVS =
  Models: {}
  Collections: {}
  Views: {}
  Routers: {}
  Stores: {}

window.ReportRowConfig =
  wait: 2000
